/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable react/no-unknown-property */
import { IComponentProps } from '@msdyn365-commerce/core';
import React from 'react';
import { FaFile, FaFileExcel, FaFileImage, FaFilePdf, FaFilePowerpoint, FaFileWord, FaGoogleDrive, FaLeanpub } from 'react-icons/fa';
import { IMoeKwrSearchResultContainerResources } from '../moe-kwr-search-result-container.props.autogenerated';
export interface ICollectionItemComponentProps extends IComponentProps<{}> {
    className?: string;
    artifacts: any;
    showMoreArtifacts: any;
    ArtifactsDataAttributes: any;
    resources?: IMoeKwrSearchResultContainerResources;
    preferredLanguageForError: string;
    siteName?: string;
}

export const ArtifactsListView: React.FC<ICollectionItemComponentProps> = (props: any) => {
    const { artifacts, className, resources, preferredLanguageForError } = props;
    console.log('external resources', artifacts);

    // variable declaration
    const IMSCCRemovedArtifacts = artifacts.filter(
        (artifact: any) =>
            artifact?.FILETYPE?.toUpperCase() !== 'IMSCC' && !(artifact?.MEDIANAME as string).includes('CogSearchIndexHelper')
    );

    return (
        <>
            {IMSCCRemovedArtifacts && IMSCCRemovedArtifacts.length > 0 ? (
                <div className={className}>
                    {IMSCCRemovedArtifacts?.map((artifact: any, index: number) => (
                        <ArtifactResource id={artifact.Id} artifact={artifact} key={artifact.Id} />
                    ))}
                    {/* <div className='moe-search-artifacts-resources-showmore--btn'> */}
                    {/* <button onClick={showMoreExternalResources} className='moe-btn moe-btn--primary-blue'> */}
                    {/* Show More */}
                    {/* <span className='moe-search-ext-resources-showmore--spinner'></span> */}
                    {/* </button> */}
                    {/* </div> */}
                </div>
            ) : (
                <div className='msc-alert msc-alert-warning'>
                    {preferredLanguageForError === 'maori' ? resources.resultSearchNotFoundTextInMaori : resources.resultSearchNotFoundText}
                    .
                </div>
            )}
        </>
    );
};

const ArtifactResource = (props: any) => {
    const { artifact } = props;

    return (
        <div className='moe-search-artifacts-resource'>
            <div className='moe-search-ext-resource__header'>
                <a
                    target='_blank'
                    download={artifact?.MEDIANAME}
                    rel='noreferrer'
                    className='tooltip-test'
                    title='Word File'
                    href={artifact.MEDIAURL}
                    aria-label={`Read More about ${artifact.MEDIAURL}`}
                >
                    {getArtifactIcon(artifact.FILETYPE)}
                </a>
                <p>{artifact?.MEDIANAME || 'Resource name is not available for this.'}</p>
            </div>
            <div className='moe-search-ext-resource__footer'>
                <p>
                    <b>Resource: </b>
                    {artifact?.MEDIANAME || 'Resource name is not available for this.'}
                </p>
                <p>
                    <b>Format: </b>.{artifact?.FILETYPE?.toLowerCase() || 'ext'}
                </p>
            </div>
        </div>
    );
};

const getArtifactIcon = (FILETYPE: any): any => {
    const fileType = FILETYPE?.toUpperCase();
    switch (fileType) {
        case 'DOC':
            return <FaFileWord />;
        case 'IMAGE':
            return <FaFileImage />;
        case 'EXCEL':
            return <FaFileExcel />;
        case 'PPT':
            return <FaFilePowerpoint />;
        case 'EPUB':
            return <FaLeanpub />;
        case 'PDF':
            return <FaFilePdf />;
        case 'GOOGLEDOC':
            return <FaGoogleDrive />;
        case 'IMSCC':
            break;
        default:
            return <FaFile />;
    }
};
